// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import all your page components and the private route wrapper
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import PrivateRoute from './components/PrivateRoute';

import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import AdmissionBrochurePage from './pages/AdmissionBrochurePage';
import GenericPdfPage from './pages/GenericPdfPage';
import FeedbackFormPage from './pages/FeedbackFormPage';

// Standalone imported sections
import PARProfilePage from './pages/PARProfilePage';
import StudentDetailsPage from './pages/StudentDetailsPage';
import TeachingStaffPage from './pages/TeachingStaffPage';
import StaffAchievementsPage from './pages/StaffAchievementsPage';
import BEdPage from './pages/BEdPage';
import DSMPage from './pages/DSMPage';
import MAEduPage from './pages/MAEduPage';
import LibraryPage from './pages/LibraryPage';
import IQACPage from './pages/IQACPage';
import NAACReportsPage from './pages/NAACReportsPage';
import PlacementPolicyPage from './pages/PlacementPolicyPage';
import InfrastructurePage from './pages/InfrastructurePage';
import RulesRegulationsPage from './pages/RulesRegulationsPage';
import MissionOfLibraryPage from './pages/MissionOfLibraryPage';
import PeerTeamVisitPage from './pages/PeerTeamVisitPage';
import PlacementCellPage from './pages/PlacementCellPage';
import PlacementRecordsPage from './pages/PlacementRecordsPage';
import AlumniRegistrationPage from './pages/AlumniRegistrationPage';
import CollegeEventsPage from './pages/CollegeEventsPage';
import CampusLifePage from './pages/CampusLifePage';
import BloodDonationPage from './pages/BloodDonationPage';
import InfrastructureGalleryPage from './pages/InfrastructureGalleryPage';
import SocialActivityPage from './pages/SocialActivityPage';
import SportsGalleryPage from './pages/SportsGalleryPage';
import RampPage from './pages/RampPage';
import CulturePage from './pages/CulturePage';

// Import all PDFs and Images for generic pages
import admissionFormFile from './images/admission form.pdf';
import studentAdmissionListFile from './images/yearwisestudentdetails.pdf';
import academicCalendarFile from './images/academic calender 23-25.pdf';
import syllabusFile from './images/syullubus.pdf';
import antiRaggingFile from './images/anti-ragging.jpg';
import womenCellFile from './images/women-cell.jpg';
import grievanceFile from './images/G & R.pdf';
import studentCouncilFile from './images/student-council.jpg';
import scholarshipsFile from './images/scholarshipandaward.jpg';

// --- NEW NAVBAR FILES ---
import libGlanceFile from './images/libraryatglance-image.jpg';
import libMissionFile from './images/liberary of B.ED.pdf';
import iqacObjectiveFile from './images/IQAC-objective.pdf';
import iqacMemberFile from './images/IQAC-member.jpg';
import iqacActivityFile from './images/IQAC-activity&reports.pdf';
import peerTeamFile from './images/preteamvisit.jpg';
import ssrReportFile from './images/SSR-report.pdf';
import auditReportFile from './images/AUDIT-REPORT.pdf';
import aisheReportFile from './images/AISHE-report.pdf';
import uniAffiliationFile from './images/UNIVERSITY-AFFILIATION.pdf';
import naacCertFile from './images/NAAC CERTIFICATE.pdf';
import placementCellFile from './images/Placement cell.pdf';
import placementRecordsFile from './images/PLACEMENTCELL-PHOTO.jpg';
import internshipOppFile from './images/INTERNSHIPOPP.jpg';
import alumniReportFile from './images/Allumani Report.pdf';
import dheLetterFile from './images/2025-26 DHE APPROVED LETTER.pdf';
import landDetailsFile from './images/LANDDETAILS.pdf';
import buildingMapFile from './images/BUILDINGMAP.pdf';
import completionCertFile from './images/buildingcompletioncertificate.pdf';
import rampFile from './images/abc.jpg';
import landTitleFile from './images/land Title Certificate.pdf';
import landUseFile from './images/Land Use Certificate.pdf';
import fireSafetyFile from './images/Fire sefty certificate_2.pdf';
import naOrderFile from './images/NA order.pdf';
import noImbalanceFile from './images/NO-IMBULANCE.pdf';
import kharediFile from './images/KHAREDI.pdf';

// Vacancy2026 files

import vacancyReportFile from './images/vacancy report for against cap round 2026.pdf';
import vacancyAdvertisementFile from './images/adverstise of vacancy.pdf';

import Vacancy2026Page from './pages/Vacancy2026Page';

// Merit list published 

import firstMeritFourthRoundFile from './images/1st Merit 4th Round Active.pdf';

function App() {
  return (
    <Router>
      <Routes>
        {/* ========================================================== */}
        {/* PUBLIC ROUTES: Accessible to everyone */}
        {/* ========================================================== */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        
        {/* Add more public routes here for things like the about page, etc. */}
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/admission-brochure" element={<AdmissionBrochurePage />} />
        
        {/* Left Sidebar generic routes */}
        <Route path="/admission-form" element={<GenericPdfPage title="Admission Form" fileUrl={admissionFormFile} />} />
        <Route path="/student-admission-list" element={<GenericPdfPage title="Year wise Student Admission List" fileUrl={studentAdmissionListFile} />} />
        
        {/* Feedback Forms */}
        <Route path="/alumni-feedback" element={<FeedbackFormPage title="Alumni Feedback" type="alumni-feedback" description="We value your continued connection and insights. Your feedback helps us improve our institution and provide better opportunities for our current and future students." />} />
        <Route path="/teacher-feedback" element={<FeedbackFormPage title="Teacher Feedback" type="teacher-feedback" description="We value your professional insights and suggestions. Your feedback helps us enhance our academic programs and facilities for both faculty and students." />} />
        <Route path="/student-feedback" element={<FeedbackFormPage title="Student Feedback" type="student-feedback" description="Your experience matters to us. Your feedback is crucial in helping us improve our courses, facilities, and campus life to provide the best possible education environment." />} />
        
        <Route path="/academic-calendar" element={<GenericPdfPage title="Academic Calendar" fileUrl={academicCalendarFile} />} />
        <Route path="/rules-regulations" element={<RulesRegulationsPage />} />
        <Route path="/syllabus" element={<GenericPdfPage title="Syllabus" fileUrl={syllabusFile} />} />
        <Route path="/anti-ragging" element={<GenericPdfPage title="Anti Ragging" fileUrl={antiRaggingFile} isImage={true} />} />
        <Route path="/women-cell" element={<GenericPdfPage title="Women Cell" fileUrl={womenCellFile} isImage={true} />} />
        <Route path="/grievance" element={<GenericPdfPage title="Grievance & Redressal Committee" fileUrl={grievanceFile} />} />
        <Route path="/student-council" element={<GenericPdfPage title="Student Council" fileUrl={studentCouncilFile} isImage={true} />} />
        <Route path="/scholarships" element={<GenericPdfPage title="Scholarships & Awards" fileUrl={scholarshipsFile} isImage={true} />} />

        {/* ========================================================== */}
        {/* STANDALONE SECTIONS ROUTES */}
        {/* ========================================================== */}
        <Route path="/par-profile" element={<PARProfilePage />} />
        <Route path="/student-details" element={<GenericPdfPage title="Student Details - DHE Approved Letter" fileUrl={dheLetterFile} />} />
        <Route path="/teaching-staff" element={<TeachingStaffPage />} />
        <Route path="/staff-achievements" element={<StaffAchievementsPage />} />
        <Route path="/bed" element={<BEdPage />} />
        <Route path="/dsm" element={<DSMPage />} />
        <Route path="/ma-education" element={<MAEduPage />} />
        
        {/* Expanded Navigation Dropdown Routes */}
        {/* Library Sub-Items */}
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/library-at-a-glance" element={<GenericPdfPage title="Library at a Glance" fileUrl={libGlanceFile} isImage={true} />} />
        <Route path="/mission-of-library" element={<MissionOfLibraryPage />} />

        {/* IQAC Sub-Items */}
        <Route path="/iqac" element={<IQACPage />} />
        <Route path="/iqac-objectives" element={<GenericPdfPage title="IQAC Objectives" fileUrl={iqacObjectiveFile} />} />
        <Route path="/iqac-members" element={<GenericPdfPage title="IQAC Members" fileUrl={iqacMemberFile} isImage={true} />} />
        <Route path="/iqac-activities" element={<GenericPdfPage title="Activities & Reports" fileUrl={iqacActivityFile} />} />

        {/* NAAC Sub-Items */}
        <Route path="/naac" element={<NAACReportsPage />} />
        <Route path="/naac-peer-team-visit" element={<PeerTeamVisitPage />} />
        <Route path="/naac-ssr" element={<GenericPdfPage title="Self Study Report (SSR)" fileUrl={ssrReportFile} />} />
        <Route path="/naac-audit-report" element={<GenericPdfPage title="Audit Report" fileUrl={auditReportFile} />} />
        <Route path="/naac-aishe-report" element={<GenericPdfPage title="AISHE Report" fileUrl={aisheReportFile} />} />
        <Route path="/naac-university-affiliation" element={<GenericPdfPage title="University Affiliation" fileUrl={uniAffiliationFile} />} />
        <Route path="/naac-certificate" element={<GenericPdfPage title="NAAC Certificate" fileUrl={naacCertFile} />} />

        {/* Placement Sub-Items */}
        <Route path="/placement" element={<PlacementPolicyPage />} />
        <Route path="/placement-cell" element={<PlacementCellPage />} />
        <Route path="/placement-records" element={<PlacementRecordsPage />} />
        <Route path="/internship-opportunities" element={<GenericPdfPage title="Internship Opportunities" fileUrl={internshipOppFile} isImage={true} />} />

        {/* Alumni Sub-Items */}
        <Route path="/alumni-association" element={<GenericPdfPage title="Alumni Association" fileUrl={alumniReportFile} />} />
        <Route path="/alumni-registration" element={<AlumniRegistrationPage />} />

        <Route path="/college-events" element={<CollegeEventsPage />} />
        <Route path="/campus-life" element={<CampusLifePage />} />
        <Route path="/blood-donation-camp" element={<BloodDonationPage />} />
        <Route path="/infrastructure-gallery" element={<InfrastructureGalleryPage />} />
        <Route path="/social-activity" element={<SocialActivityPage />} />
        <Route path="/sports-gallery" element={<SportsGalleryPage />} />
        <Route path="/cultural-gallery" element={<CulturePage />} />

        {/* Infrastructure Sub-Items */}
        <Route path="/infrastructure" element={<InfrastructurePage />} />
        <Route path="/infrastructure-land-details" element={<GenericPdfPage title="Land Details" fileUrl={landDetailsFile} />} />
        <Route path="/infrastructure-building-map" element={<GenericPdfPage title="Building Map" fileUrl={buildingMapFile} />} />
        <Route path="/infrastructure-completion-certificate" element={<GenericPdfPage title="Completion Certificate" fileUrl={completionCertFile} />} />
        <Route path="/infrastructure-ramp" element={<RampPage />} />
        <Route path="/infrastructure-land-title" element={<GenericPdfPage title="Land Title Certificate" fileUrl={landTitleFile} />} />
        <Route path="/infrastructure-land-use" element={<GenericPdfPage title="Land Use Certificate" fileUrl={landUseFile} />} />
        <Route path="/infrastructure-fire-safety" element={<GenericPdfPage title="Fire Safety" fileUrl={fireSafetyFile} />} />
        <Route path="/infrastructure-na" element={<GenericPdfPage title="NA Order" fileUrl={naOrderFile} />} />
        <Route path="/infrastructure-non-imbalance" element={<GenericPdfPage title="Non-Imbalance" fileUrl={noImbalanceFile} />} />
        <Route path="/infrastructure-kharedi-khat" element={<GenericPdfPage title="Kharidi-Khat" fileUrl={kharediFile} />} />
        <Route path="/vacancy-of-2026" element={<Vacancy2026Page vacancyReport={vacancyReportFile} vacancyAdvertisement={vacancyAdvertisementFile} firstMeritFourthRound={firstMeritFourthRoundFile} />} />

        {/* ========================================================== */}
        {/* PRIVATE ROUTES: Only accessible to authenticated users */}
        {/* ========================================================== */}
        <Route path="/admin" element={<PrivateRoute />}>
          <Route index element={<AdminDashboard />} />
        </Route>

        <Route path="*" element={<div>404 Page Not Found</div>} />

      </Routes>
    </Router>
  );
}

export default App;
